module.exports = __webpack_public_path__ + "static/media/6.24_preview.e4f5bcfb.png";